// extracted by mini-css-extract-plugin
export default {"mainDiv404":"Page404_mainDiv404__zE3hQ","text404":"Page404_text404__Gmf3C"};